import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=47cd101a&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=47cd101a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cd101a",
  null
  
)

export default component.exports